import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { PublicHeader } from "./Showcase";

export default function Unsubscribe() {
  const [q] = useSearchParams();
  const [res, setRes] = useState(null);
  useEffect(() => {
    const t = q.get("t");
    if (!t || t === "preview") { setRes({ err: t === "preview" ? "This is a preview link from a test email." : "This unsubscribe link is missing its code." }); return; }
    api.post("/public/unsubscribe", { token: t }).then((r) => setRes(r.data)).catch((e) => setRes({ err: errMsg(e) }));
  }, [q]);
  return (
    <div className="min-h-screen" data-testid="unsubscribe-page">
      <PublicHeader back />
      <div className="max-w-lg mx-auto px-4 py-24 text-center">
        <h1 className="font-display text-4xl mb-4">{res?.err ? "Link not valid" : "Unsubscribe"}</h1>
        {!res && <p className="text-slate-400">One moment…</p>}
        {res?.err && <p className="text-amber-500" data-testid="unsubscribe-error">{res.err}</p>}
        {res?.ok && <p className="text-slate-300" data-testid="unsubscribe-success">{res.kind === "newsletter" ? "You've been removed from the newsletter. You won't get any more emails from it." : `Your release reminder${res.title ? ` for ${res.title}` : ""} is cancelled.`}</p>}
        <Link to="/authors" className="inline-block mt-8 text-sm text-amber-200 hover:text-white" data-testid="unsubscribe-back">Back to the books</Link>
      </div>
    </div>
  );
}
